"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ColorInput = _interopRequireDefault(require("./ColorInput"));
var _ColorSwatch = _interopRequireDefault(require("./ColorSwatch"));
var _ColorLabel = _interopRequireDefault(require("./ColorLabel"));
var _ColorIcon = _interopRequireDefault(require("./ColorIcon"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");
var _typography = require("@vds/typography");
var _theme = require("@vds/theme");
var _utilities = require("@vds-core/utilities");
var _templateObject, _templateObject2;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var propTypes = {
  /**
   * @deprecated
   */
  className: _propTypes["default"].string,
  /**
   * If provided, the color of the RadioSwatch will be rendered.
   */
  color: _propTypes["default"].string,
  /**
   * @deprecated
   */
  disabled: _propTypes["default"].bool,
  /**
   * If provided, the label of the RadioSwatch will be rendered.
   */
  label: _propTypes["default"].string,
  /**
   * Name of RadioSwatch.
   */
  name: _propTypes["default"].string,
  /**
   * Callback function that returns the value of the RadioSwatch when clicked.
   */
  onChange: _propTypes["default"].func,
  /**
   * Value of RadioSwatch.
   */
  value: _propTypes["default"].string.isRequired,
  /**
   * If provided, the Radio will be rendered in the Selected State.
   */
  selected: _propTypes["default"].bool,
  /**
   * @deprecated selected
   */
  checked: _propTypes["default"].bool,
  /**
   * @ignore
   */
  bodyConfig: _propTypes["default"].object,
  /**
   * @ignore
   */
  focusSize: _propTypes["default"].func,
  /**
   * @ignore
   */
  focusState: _propTypes["default"].bool,
  /**
   * @ignore
   */
  labelMargin: _propTypes["default"].number,
  /**
   * @ignore
   */
  labelMaxWidth: _propTypes["default"].number,
  /**
   * @ignore
   */
  labelMinWidth: _propTypes["default"].number,
  /**
   * @ignore
   */
  swatchMargin: _propTypes["default"].func,
  /**
   * @ignore
   */
  size: _propTypes["default"].number,
  /**
   * @ignore
   */
  typescale: _propTypes["default"].string,
  /**
   * @ignore
   */
  typographyConfig: _propTypes["default"].object,
  /**
   * @ignore
   */
  selectedStateDoubleBorder: _propTypes["default"].bool,
  /**
   * @ignore
   */
  outOfStock: _propTypes["default"].bool,
  /**
   * @ignore
   */
  colorConfig: _propTypes["default"].object,
  /**
   * Allows a string to be provided for analytics.
   */
  "data-analyticstrack": _propTypes["default"].string,
  /**
   * Allows a string to be provided for analytics.
   */
  "data-track": _propTypes["default"].string,
  /**
   * Allows a string to be ignored for analytics.
   */
  "data-track-ignore": _propTypes["default"].string,
  /**
   * Allows a string to be provided for click stream.
   */
  "data-clickstream": _propTypes["default"].string,
  /**
   * Allows a unique ID to be passed to the component.
   */
  id: _propTypes["default"].string,
  /**
   * Allows a unique ID to be passed to the input element.
   */
  inputId: _propTypes["default"].string,
  /**
   * @ignore
   */
  disabledState: _propTypes["default"].bool,
  /**
   * @ignore
   */
  inverted: _propTypes["default"].bool
};

//Move to VDS
function _determineSwatchMargin() {
  return "".concat((0, _theme.calculateSpacing)("1X"), " auto");
}
var defaultProps = {
  className: null,
  color: "Black",
  disabled: false,
  inverted: false,
  label: null,
  name: null,
  onChange: function onChange() {},
  selected: false,
  //1.0
  bodyConfig: _typography.BodyConfig,
  focusSize: undefined,
  focusState: false,
  labelMargin: 4,
  labelMaxWidth: 120,
  labelMinWidth: 44,
  swatchMargin: _determineSwatchMargin,
  size: 24,
  typographyConfig: _typography.TypographyConfig,
  selectedStateDoubleBorder: false,
  outOfStock: false,
  disabledState: true,
  colorConfig: _theme.colors
};
var SwatchWrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "SwatchWrapper",
  componentId: "sc-1hiijnm-0"
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])([""])));
var ComponentWrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "ComponentWrapper",
  componentId: "sc-1hiijnm-1"
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  flex-basis: 100%;\n  flex-direction: column;\n  justify-content: flex-start;\n  position: relative;\n  max-width: ", ";\n  min-width: ", ";\n  &:not(:last-child) {\n    margin-right: ", ";\n  }\n"])), function (_ref) {
  var maxWidth = _ref.maxWidth;
  return (0, _javascriptStyleHelpers.calculateRem)(maxWidth);
}, function (_ref2) {
  var minWidth = _ref2.minWidth;
  return (0, _javascriptStyleHelpers.calculateRem)(minWidth);
}, function (_ref3) {
  var margin = _ref3.margin;
  return (0, _javascriptStyleHelpers.calculateRem)(margin);
});
var RadioSwatch = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(RadioSwatch, _React$Component);
  var _super = _createSuper(RadioSwatch);
  function RadioSwatch(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, RadioSwatch);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChange", function (e) {
      var hovered = _this.state.hovered;
      if (hovered) _this.setState({
        showFocus: false
      });else _this.setState({
        showFocus: true
      });
      if (_this.isControlled) {
        _this.props.onChange(e);
      } else {
        _this.setState(function (prevState) {
          return {
            selected: !prevState.selected
          };
        });
      }
    });
    /* These are used to remove focus state onClick, blurring elements does not work with screen readers */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_addHover", function (e) {
      if (!_this.state.hovered) _this.setState({
        hovered: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_removeHover", function (e) {
      return _this.setState({
        hovered: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onFocus", function (e) {
      if (!_this.state.hovered) _this.setState({
        showFocus: true
      });else _this.setState({
        showFocus: false
      });
    });
    _this.state = {
      selected: _this.props.selected || _this.props.checked || false,
      showFocus: true
    };
    return _this;
  }
  (0, _createClass2["default"])(RadioSwatch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isControlled = this.props.checked !== undefined || this.props.selected !== undefined;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps && prevProps.selected !== this.props.selected) {
        this.setState(function (prevProps) {
          return {
            selected: !prevProps.selected
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        checked = _this$props.checked,
        color = _this$props.color,
        disabled = _this$props.disabled,
        label = _this$props.label,
        name = _this$props.name,
        onChange = _this$props.onChange,
        selectedProp = _this$props.selected,
        idProp = _this$props.id,
        bodyConfig = _this$props.bodyConfig,
        typographyConfig = _this$props.typographyConfig,
        value = _this$props.value,
        focusSize = _this$props.focusSize,
        focusState = _this$props.focusState,
        labelMargin = _this$props.labelMargin,
        labelMaxWidth = _this$props.labelMaxWidth,
        labelMinWidth = _this$props.labelMinWidth,
        swatchMargin = _this$props.swatchMargin,
        size = _this$props.size,
        typescale = _this$props.typescale,
        selectedStateDoubleBorder = _this$props.selectedStateDoubleBorder,
        outOfStock = _this$props.outOfStock,
        disabledState = _this$props.disabledState,
        colorConfig = _this$props.colorConfig,
        numberOfSwatches = _this$props.numberOfSwatches,
        analyticsTrack = _this$props["data-analyticstrack"],
        track = _this$props["data-track"],
        clickStream = _this$props["data-clickstream"],
        trackIgnore = _this$props["data-track-ignore"],
        inputId = _this$props.inputId,
        inverted = _this$props.inverted;
      var selected = this.state.selected;
      var radioId = inputId ? inputId : (0, _utilities.generateUUID)();
      function _checkIfIe() {
        var isAriaHidden = false;
        var ua = typeof window !== "undefined" ? window.navigator.userAgent : null;
        var msie = ua.indexOf("MSIE ");
        if (msie > 0) {
          isAriaHidden = true;
        }
        var trident = ua.indexOf("Trident/");
        if (trident > 0) {
          isAriaHidden = true;
        }
        return isAriaHidden;
      }
      var labelText = disabled || outOfStock ? label + " - Out of Stock" : label;
      var ariaDisplay = value;
      return /*#__PURE__*/_react["default"].createElement(ComponentWrapper, {
        maxWidth: labelMaxWidth,
        minWidth: labelMinWidth,
        margin: labelMargin,
        onMouseEnter: this._addHover,
        onMouseLeave: this._removeHover
      }, /*#__PURE__*/_react["default"].createElement(_ColorInput["default"], {
        numberOfSwatches: numberOfSwatches,
        checked: selected,
        focusSize: focusSize,
        focusState: focusState,
        inverted: inverted,
        id: radioId,
        role: "radio",
        size: size,
        type: "radio",
        value: value,
        colorConfig: colorConfig,
        outOfStock: outOfStock,
        "data-analyticstrack": analyticsTrack,
        "data-track": track,
        "data-clickstream": clickStream,
        "data-track-ignore": trackIgnore,
        onChange: this._onChange,
        tabIndex: selected ? 0 : -1,
        showFocus: this.state.showFocus,
        onFocus: this._onFocus
      }), /*#__PURE__*/_react["default"].createElement(_ColorLabel["default"], (0, _extends2["default"])({
        id: idProp,
        bodyConfig: bodyConfig,
        disabled: disabled && disabledState,
        outOfStock: outOfStock,
        labelMargin: labelMargin,
        labelMaxWidth: labelMaxWidth,
        labelMinWidth: labelMinWidth,
        typescale: typescale,
        typographyConfig: typographyConfig,
        focusSize: focusSize,
        colorConfig: colorConfig,
        htmlFor: radioId,
        inverted: inverted
      }, this.props), /*#__PURE__*/_react["default"].createElement(_ColorSwatch["default"], {
        active: selected,
        color: color,
        disabled: disabled || outOfStock,
        outOfStock: outOfStock,
        selected: selected,
        swatchMargin: swatchMargin,
        size: size,
        tabIndex: -1,
        colorConfig: colorConfig
      }, /*#__PURE__*/_react["default"].createElement(_ColorIcon["default"], {
        disabled: disabled && disabledState,
        outOfStock: outOfStock,
        selected: selected,
        tabIndex: -1,
        value: value,
        selectedStateDoubleBorder: selectedStateDoubleBorder,
        colorConfig: colorConfig,
        surface: this.props.inverted ? "dark" : "light"
      })), /*#__PURE__*/_react["default"].createElement(SwatchWrapper, {
        "aria-hidden": _checkIfIe(),
        tabIndex: -1
      }, labelText)));
    }
  }]);
  return RadioSwatch;
}(_react["default"].Component);
RadioSwatch.propTypes = propTypes;
RadioSwatch.defaultProps = defaultProps;
var _default = exports["default"] = (0, _utilities.withVDSManager)(RadioSwatch);


//////////////////
// WEBPACK FOOTER
// ./~/@vds/inputs/dist/cjs/components/RadioSwatch/RadioSwatch.js
// module id = 570
// module chunks = 0